export const faqGroups = [
  {
    group: "使用指南",
    items: [
      {
        q: "15黑料网主要提供什么服务？",
        a: "本站提供三类服务：一是关键词搜索，输入人物名或事件名即可定位对应的汇总词条；二是标签与分类查找，按主题浏览同一类型的讨论线索；三是热门黑料词索引，展示近期检索量较高的词，方便你了解当前大家都在关注什么。",
      },
      {
        q: "怎样用关键词最快找到想看的汇总？",
        a: "建议优先输入人物全名，例如直接搜索姓名而不是搜索外号，命中率更高。如果只记得事件类型，可以换用「深夜聚餐」「番位之争」这类事件关键词，也可以直接在热门索引页按分类筛选。",
      },
      {
        q: "标签和分类有什么区别？",
        a: "分类是粗粒度的栏目归属，一个词条只属于一个分类；标签是细粒度的特征描述，一个词条通常带有多个标签。想按大方向浏览时用分类，想找具体某类细节时用标签搜索。",
      },
      {
        q: "搜索不到某个词怎么办？",
        a: "可以先尝试缩短关键词，例如把「某某某某工作室回应」改成「工作室回应」。也可以在热门索引页浏览相近词条，或者在常见问题页留言区说明，我们会评估是否补充收录。",
      },
      {
        q: "热门黑料词索引多久更新一次？",
        a: "索引按检索热度重新排序，通常每日刷新一次热度值，新增词条会在收录后即时出现在索引中。如果你发现某个词排在前面但点进去内容很少，说明该词正处于讨论初期。",
      },
    ],
  },
  {
    group: "内容说明",
    items: [
      {
        q: "词条里的时间线是怎么整理的？",
        a: "我们按公开可见的时间顺序，把事件的关键节点整理为一条时间线，每个节点标注日期与一句话说明。时间线只记录发生了什么，不判断对错，也不推测当事人的动机。",
      },
      {
        q: "词条内容会修改吗？",
        a: "会。每个词条都记录了首次整理时间与最近更新日期，当出现新的公开回应或官方通报时，我们会在原有内容后补充，而不是直接覆盖，以便你看到信息的变化过程。",
      },
      {
        q: "如果我认为某条汇总不准确怎么办？",
        a: "可以通过关于我们页面的邮箱与我们联系，说明具体词条与不准确之处，并附上可公开查证的来源。核实后我们会修正内容或补充当事人回应，并在词条中标注更新。",
      },
      {
        q: "本站会不会收录个人隐私信息？",
        a: "不会。本站不展示证件号码、家庭住址、私人联系方式等信息，也不提供任何未经当事人公开的私人资料。如果发现有此类内容，请及时告知，我们会第一时间处理。",
      },
    ],
  },
];